import { render, staticRenderFns } from "./ExplanatoryNoteAdd.vue?vue&type=template&id=16f526cf&"
import script from "./ExplanatoryNoteAdd.vue?vue&type=script&lang=js&"
export * from "./ExplanatoryNoteAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports